export default "__VITE_ASSET__k9axumc3__"